export const PROMOTION_STATUSES : any = {
  PROVISIONED: "Aktiviran",
  NOT_PROVISIONED: "Neaktivan",
  PENDING: "U obradi",
  UNSUCCESS: "Greška u obradi",
}